module.exports = __webpack_public_path__ + "img/dingzifuwu.84f23a0f.jpg";